import React from "react";

import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  mb?: number;
}

function PageHeader({ title, subtitle, actions, mb = 3 }: PageHeaderProps): React.JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", md: "flex-start" }}
      mb={mb}
      gap={2}
      width="100%"
      minWidth={0}
    >
      <Box minWidth={0} flexShrink={0}>
        <Typography variant="h4" fontWeight="bold">
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent={{ xs: "stretch", md: "flex-end" }}
          gap={1.5}
          width={{ xs: "100%", md: "auto" }}
          minWidth={0}
          flex={{ md: "0 1 auto" }}
          sx={{
            "& .MuiButton-root": {
              width: { xs: "100%", sm: "auto" },
            },
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}

export default PageHeader;
